import script from "./SkinsGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./SkinsGenerator.vue?vue&type=script&setup=true&lang=js"

import "./SkinsGenerator.vue?vue&type=style&index=0&id=5ca0bb1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca0bb1e"]])

export default __exports__